import { asyncComponent } from 'react-async-component'
import type { ComponentType } from 'react'

interface NewRouteProps {
  path?: string
  exact?: boolean
  strict?: boolean
  component?: ComponentType<any>
  title?: string
}

const routes: NewRouteProps[] = [
  {
    path: '/',
    component: asyncComponent({
      resolve: () => import('./views/LoggedIn')
    })
  },
  {
    path: '/login',
    title: 'Login',
    component: asyncComponent({
      resolve: () => import('./views/LoggedOut/')
    })
  },
  {
    path: '/login-success',
    title: 'Login Success',
    component: asyncComponent({
      resolve: () => import('./views/LoggedOut/LoginSuccess')
    })
  },
  {
    path: '/login-failed',
    title: 'Login Failed',
    component: asyncComponent({
      resolve: () => import('./views/LoggedOut/LoginFailed')
    })
  },
  {
    path: '/logged-out',
    title: 'LoggedOut',
    component: asyncComponent({
      resolve: () => import('./views/LoggedOut/LoggedOut')
    })
  }
  // {
  //   path: '/run-uat-tests',
  //   component: asyncComponent({
  //     resolve: () => {
  //       return window.open('https://insite-api.ieno.io/v1/trigger/pipeline')
  //     }
  //   })
  // },
  // {
  //   path: '/run-prod-tests',
  //   component: asyncComponent({
  //     resolve: () => {
  //       window.open('https://insite-api.ieno.io/v1/trigger/pipeline?ref=production')
  //     }
  //   })
  // }
]

export default routes
